﻿import React, { useState } from 'react';

import {  Button, Input, Select } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog as faCogSolid } from '@fortawesome/pro-solid-svg-icons';
import ExternalLayersModal from './ExternalLayersModal';
import { ExternalLayersStore } from '../../stores/ExternalLayersStore';
import { ExternalChartLayer } from './LayerInterfaces';

interface Props {
    layers: ExternalChartLayer[],
    showSettingsButton: boolean,
    externalLayersStore: ExternalLayersStore
}

const ExternalLayerSelect: React.FC<Props> = ({
    layers,
    showSettingsButton,
    externalLayersStore,
    ...rest
}) => {
    const [isSettingsModalVisible, setIsSettingsModalVisible] = useState(false);

    const hideSettingsModal = () => {
        setIsSettingsModalVisible(false);
    }

    if (!showSettingsButton) {
        return <>
            <Select
                style={{
                    whiteSpace: "nowrap",
                    width: '100%',
                }}
                {...rest}>
                {
                    layers.map((layer) => {
                        return <Select.Option key={layer.id} value={layer.id}>
                            {layer.name}
                        </Select.Option>
                    })
                }
            </Select>
        </>;
    }
    else {
        return <>
            <Input.Group compact>
                <Select
                    style={{
                        whiteSpace: "nowrap",
                        width: 'calc(100% - 36px)',
                    }}
                    {...rest}>
                    {
                        layers.map((layer) => {
                            return <Select.Option key={layer.id} value={layer.id}>
                                {layer.name}
                            </Select.Option>
                        })
                    }
                </Select>
                <Button onClick={() => setIsSettingsModalVisible(true)}><FontAwesomeIcon icon={faCogSolid} /></Button>
            </Input.Group>
            <ExternalLayersModal visible={isSettingsModalVisible} layers={layers} externalLayersStore={externalLayersStore} onOk={hideSettingsModal} />
        </>;
    }    
}

export default ExternalLayerSelect;